(function () {
  'use strict';

  function rate() {
    const c = window.Shopify && window.Shopify.currency;
    const r = c && parseFloat(c.rate);
    return Number.isFinite(r) && r > 0 ? r : 1;
  }

  function activeCurrency(fallback) {
    const c = window.Shopify && window.Shopify.currency;
    return (c && c.active) || fallback || 'EUR';
  }

  function convert(baseAmount) {
    const n = Number(baseAmount);
    if (!Number.isFinite(n)) return n;
    return n * rate();
  }

  function convertCents(baseCents) {
    const n = Number(baseCents);
    if (!Number.isFinite(n)) return n;
    return Math.round(n * rate());
  }

  // Commercial ("charm") price: keep the whole units and force the decimals to .99, so a
  // converted price is clean (e.g. 1141.42 -> 1141.99) in every currency. This is the single
  // source of the rule — the offer-discount / target-price / bundle / tiered / bxgy Shopify
  // Functions use the identical floor(x)+0.99 so storefront and checkout match 1:1.
  function commercial(amount) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return amount;
    // Never fabricate a price from a non-positive value (empty/absent metafield -> 0 stays 0).
    if (n <= 0) return n;
    return Math.floor(n) + 0.99;
  }

  function commercialCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return cents;
    if (n <= 0) return n;
    return Math.floor(n / 100) * 100 + 99;
  }

  function format(amount, currency) {
    const code = currency || activeCurrency();
    const nf = new Intl.NumberFormat('de-DE', { style: 'currency', currency: code });
    const parts = nf.formatToParts(Number(amount));
    const numberStr = parts
      .filter(function (p) { return p.type !== 'currency' && p.type !== 'literal'; })
      .map(function (p) { return p.value; })
      .join('');
    const symbol = (parts.find(function (p) { return p.type === 'currency'; }) || {}).value || code;
    return numberStr + ' ' + symbol;
  }

  function formatHtml(amount, currency) {
    return '<span class="money">' + format(amount, currency) + '</span>';
  }

  window.PresentmentMoney = {
    rate: rate,
    activeCurrency: activeCurrency,
    convert: convert,
    convertCents: convertCents,
    commercial: commercial,
    commercialCents: commercialCents,
    format: format,
    formatHtml: formatHtml
  };
})();
